// extracted by mini-css-extract-plugin
export default {"tableRoot":"table-module__tableRoot--XK4g4","tableBodyContainer":"table-module__tableBodyContainer--llYdA","fixedOmnibar":"table-module__fixedOmnibar--QkcXJ"};